export const DIALOG_CANCEL_ACTION = "cancel";

export type DialogCancelAction = typeof DIALOG_CANCEL_ACTION;

// TODO: USE IT ACROSS THE PROJECT
